// src/pages/Auditorias/components/ExcluirAuditoriaDialog.js
import React, { useState } from 'react';

/**
 * Confirmação de exclusão de uma auditoria.
 *
 * Não usa window.confirm de propósito: o que vai desaparecer não cabe numa
 * linha — são as transcrições, as avaliações peça a peça, o parecer e todo o
 * histórico de execuções, sem cópia nenhuma. A lista tem de estar à vista antes
 * de alguém carregar no botão vermelho.
 */
const ExcluirAuditoriaDialog = ({ auditoria, onFechar, onConfirmar }) => {
  const [ocupado, setOcupado] = useState(false);
  const [erro, setErro] = useState(null);

  const confirmar = async () => {
    setOcupado(true);
    setErro(null);
    try {
      await onConfirmar(auditoria.id);
      onFechar();
    } catch (e) {
      setErro(
        e.response?.status === 409
          ? 'Esta auditoria está a ser executada neste momento. Cancele-a primeiro e volte a tentar.'
          : e.response?.data?.message || 'Erro ao apagar a auditoria'
      );
      setOcupado(false);
    }
  };

  const pecas = Number(auditoria.pecas_total || 0);
  const avaliadas = Number(auditoria.avaliados || 0);

  return (
    <div className="aud-overlay" onClick={ocupado ? undefined : onFechar}>
      <div className="aud-modal aud-modal-pequeno" onClick={(e) => e.stopPropagation()}>
        <div className="aud-modal-cabecalho">
          <h3>Apagar auditoria</h3>
          <button
            className="aud-modal-fechar"
            onClick={onFechar}
            disabled={ocupado}
            aria-label="Fechar"
          >
            ✖
          </button>
        </div>

        <div className="aud-modal-corpo">
          <p className="aud-confirmar-alvo">
            <strong>{auditoria.nome_cliente || `Cliente ${auditoria.cod_cli}`}</strong>
            <span className="aud-mono"> · {auditoria.cod_processo}</span>
          </p>

          <p>Vai apagar definitivamente, sem cópia de segurança:</p>

          <ul className="aud-lista-perdas">
            <li>{pecas || 'as'} peças registadas{avaliadas ? `, ${avaliadas} já avaliadas` : ''} — com transcrições e avaliações</li>
            <li>a cronologia, a avaliação de ficheiros e o parecer final</li>
            <li>todo o histórico de execuções e as respectivas validações</li>
            <li>as notas de revisão escritas sobre este processo</li>
          </ul>

          <p className="aud-sub">
            O registo de custo das chamadas ao modelo (chat_log) mantém-se.
            Para voltar a ter esta auditoria é preciso corrê-la de raiz.
          </p>

          {erro && <p className="aud-erro">{erro}</p>}
        </div>

        <div className="aud-modal-rodape">
          <button className="aud-btn-secundario" onClick={onFechar} disabled={ocupado}>
            CANCELAR
          </button>
          <button className="aud-btn-perigo" onClick={confirmar} disabled={ocupado}>
            {ocupado ? 'A APAGAR…' : 'APAGAR DEFINITIVAMENTE'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExcluirAuditoriaDialog;
